import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CardView from "../../components/molecules/CardView/CardView";
import DraggableTable from "../../components/organisms/DraggableTable/DraggableTable";
import Button from "../../components/atoms/Button/Button";
import "primeicons/primeicons.css";
import "./Suppliers.scss";
import ButtonBack from "../../components/atoms/ButtonBack/ButtonBack";
import { servicesSuppliers } from "../../services/suppliers";
import { toast, Toaster } from "sonner";
import AnimatedCard from "../../components/molecules/AnimatedCard/AnimatedCard";
import SupplierForm from "./CreateSupplier/CreateSupplier";
import ConfirmDialog from "../../components/molecules/ConfirmDialog/ConfirmDialog";
import ShowSupplier from "./ShowSupplier/ShowSupplier";

const SupplierDetails = () => {
    const { name, id } = useParams();
    const [createModal, setCreateModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        itemToDelete: null,
    });
    const [pagination, setPagination] = useState({
        total: 0,
        total_pages: 0,
        current_page: 1,
        prev_page: null,
        next_page: null,
        per_page: 25,
    });

    // Definir las columnas de la tabla
    const columns = [
        {
            field: "name",
            header: "Nombre del negocio",
            sortable: true,
            width: "minmax(180px, 2fr)",
        },
        // {
        //     field: "user",
        //     header: "Usuario",
        //     sortable: true,
        //     width: "minmax(150px, 1.5fr)",
        // },
        {
            field: "whatsapp",
            header: "WhatsApp",
            sortable: true,
            width: "minmax(130px, 1fr)",
        },
        // {
        //     field: "email",
        //     header: "Email",
        //     sortable: true,
        //     width: "minmax(180px, 2fr)",
        // },
        // {
        //     field: "groups",
        //     header: "Grupos",
        //     sortable: false,
        //     body: (rowData) => {
        //         return rowData.groups.length > 0
        //             ? rowData.groups.map((group) => group.name).join(", ")
        //             : "Sin grupo";
        //     },
        // },
        {
            field: "createdAt",
            header: "Fecha de Registro",
            sortable: true,
            width: "minmax(140px, 1fr)",
            body: (rowData) => {
                return new Date(rowData.createdAt).toLocaleDateString("es-ES");
            },
        },
    ];

    const [showSupplier, setShowSupplier] = useState(false);

    const handleEdit = (rowData) => {
        setSelectedSupplier(rowData);
        console.log(rowData);
        setEditModal(true);
    };
    const handleShow = (rowData) => {
        setSelectedSupplier(rowData);
        // console.log(rowData);
        setShowSupplier(true);
    };
    const handleDelete = (rowData) => {
        setConfirmDialog({
            isOpen: true,
            itemToDelete: rowData,
        });
    };

    const confirmDelete = async () => {
        const rowData = confirmDialog.itemToDelete;
        if (!rowData || !rowData.id) return;

        const toastId = toast.loading("Eliminando proveedor...");

        try {
            const response = await servicesSuppliers.deleteSupplier(rowData.id);

            if (!response.success) {
                toast.error(
                    response.message || "Error al eliminar el proveedor",
                    { id: toastId },
                );
                return;
            }

            toast.success(
                response.message || "Proveedor eliminado exitosamente",
                { id: toastId },
            );

            setSuppliers(
                suppliers.filter((supplier) => supplier.id !== rowData.id),
            );
        } catch (error) {
            toast.error("Error al eliminar el proveedor", { id: toastId });
        }
    };

    const handlePageChange = (page, rowsPerPage) => {
        getSuppliers(page, rowsPerPage, searchTerm);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
    };

    // const handleAddSupplier = () => {
    //     // Aquí va la lógica para agregar un proveedor al grupo
    // };

    const handleReorder = async (reorderedData) => {
        // Optimistic update
        setSuppliers(reorderedData);

        // Preparar el payload para el API
        const items = reorderedData.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        try {
            const response = await servicesSuppliers.reorderSuppliers(
                items,
                id || null,
            );

            if (response.success) {
                toast.success(
                    response.message || "Orden actualizado exitosamente",
                );
            } else {
                // Revertir en caso de error
                getSuppliers(
                    pagination.current_page,
                    pagination.per_page,
                    searchTerm,
                );
                toast.error(response.message || "Error al actualizar el orden");
            }
        } catch (error) {
            console.error("Error al reordenar:", error);
            // Revertir en caso de error
            getSuppliers(
                pagination.current_page,
                pagination.per_page,
                searchTerm,
            );
            toast.error("Error al actualizar el orden");
        }
    };

    const getSuppliers = async (page = 1, perPage = 25, search = "") => {
        setLoading(true);
        try {
            const response = await servicesSuppliers.getSuppliers(
                page,
                perPage,
                id,
                search,
            );

            if (!response.success) {
                toast.error(
                    response.message || "Error al cargar los proveedores",
                );
                return;
            }

            // Actualizar los datos y la paginación
            setSuppliers(response.data.data);

            // Transformar la metadata al formato esperado por DataTable
            const meta = response.data.meta;
            setPagination({
                total: meta.total,
                total_pages: meta.totalPages,
                current_page: meta.currentPage,
                prev_page: meta.prevPage,
                next_page: meta.nextPage,
                per_page: meta.perPage,
            });
        } catch (error) {
            console.error("Error al obtener proveedores:", error);
            toast.error("Error al cargar los proveedores");
        } finally {
            setLoading(false);
        }
    };

    // Efecto para búsqueda con debounce (también carga inicial)
    useEffect(() => {
        const delaySearch = setTimeout(() => {
            getSuppliers(1, pagination.per_page, searchTerm);
        }, 300); // Reducido a 300ms para mejor UX

        return () => clearTimeout(delaySearch);
        // eslint-disable-next-line
    }, [searchTerm]);

    return (
        <CardView className="suppliers">
            <div className="suppliers__header">
                <div className="suppliers__header-left">
                    <ButtonBack to="/proveedores" />

                    <div>
                        <h1 className="suppliers__title">
                            {decodeURIComponent(name)}
                        </h1>
                        <p className="suppliers__subtitle">
                            Proveedores del grupo
                        </p>
                    </div>
                </div>

                <div className="suppliers__header-right">
                    <div className="suppliers__search">
                        <div className="suppliers__search-container">
                            <i className="pi pi-search suppliers__search-icon"></i>
                            <input
                                type="text"
                                placeholder="Buscar proveedor por nombre, usuario, email..."
                                value={searchTerm}
                                onChange={handleSearch}
                                className="suppliers__search-input"
                            />
                            {searchTerm && (
                                <i
                                    className="pi pi-times suppliers__search-clear"
                                    onClick={() => setSearchTerm("")}
                                ></i>
                            )}
                        </div>
                    </div>
                    <Button
                        text={"Nuevo Proveedor"}
                        className="suppliers__addBtn degrad"
                        onClick={() => setCreateModal(true)}
                    />
                </div>
            </div>

            <DraggableTable
                data={suppliers}
                columns={columns}
                loading={loading}
                onReorder={handleReorder}
                showActions={true}
                onEdit={handleEdit}
                onShow={handleShow}
                onDelete={handleDelete}
                emptyMessage="No hay proveedores en este grupo"
                striped={true}
                hoverable={true}
                idField="id"
                pagination={pagination}
                onPageChange={handlePageChange}
                rowsPerPageOptions={[10, 25, 50, 100]}
            />

            {createModal && (
                <AnimatedCard
                    setClose={setCreateModal}
                    title="Crear Nuevo Proveedor"
                    size="lg"
                    variant="elegant"
                    coloredHeader={true}
                >
                    <SupplierForm
                        setClose={setCreateModal}
                        getSuppliers={getSuppliers}
                        isEditMode={false}
                    />
                </AnimatedCard>
            )}

            {editModal && selectedSupplier && (
                <AnimatedCard
                    setClose={setEditModal}
                    title="Editar Proveedor"
                    size="lg"
                    variant="elegant"
                    coloredHeader={true}
                >
                    <SupplierForm
                        setClose={setEditModal}
                        getSuppliers={getSuppliers}
                        supplierData={selectedSupplier}
                        isEditMode={true}
                    />
                </AnimatedCard>
            )}
            {showSupplier && selectedSupplier && (
                <ShowSupplier
                    data={selectedSupplier}
                    onClose={() => setShowSupplier(false)}
                />
            )}

            <ConfirmDialog
                isOpen={confirmDialog.isOpen}
                onClose={() =>
                    setConfirmDialog({ isOpen: false, itemToDelete: null })
                }
                onConfirm={confirmDelete}
                title="Eliminar Proveedor"
                message="¿Estás seguro de que deseas eliminar este proveedor?"
                itemName={confirmDialog.itemToDelete?.name}
                confirmText="Eliminar"
                cancelText="Cancelar"
                type="danger"
            />

            <Toaster position="top-right" richColors />
        </CardView>
    );
};

export default SupplierDetails;
